<div class="onboarding-form">
  @if (valid()) {
    <h1>Create your password</h1>
    @if (form) {
      <form
        [formGroup]="form"
        [boFormOptions]="options"
        (ngSubmit)="onSubmit()"
        class="mt-4">
        <bo-non-field-errors />
        @if (showFieldError()) {
          <div
            class="alert alert-danger"
            role="alert">
            {{ showFieldError() }}
          </div>
        }
        <app-password-field boFieldPath="password" />
        @if (showHelpText('password')) {
          <p class="text-muted small">
            Password must contain at least 8 characters and contain mixed-case letters, numbers and special characters
          </p>
        }
        <app-password-field boFieldPath="password_confirm" />
        <p class="text-muted small mb-4">Both passwords must match</p>
        <app-submit
          [btnID]="formLabel + 'SubmitBtn'"
          [busy]="busy"
          label="Create password"></app-submit>
      </form>
    } @else {
      <app-loader></app-loader>
    }
  } @else {
    <h1>Oh no...</h1>
    @if (tokenInvalid()) {
      <div>
        <p>{{ invalidDetail.title }}</p>
        @for (line of invalidDetail.text; track line) {
          <p class="text-muted">{{ line }}</p>
        }
      </div>
    }
    @if (notFound()) {
      <div>
        <p>{{ notFoundDetail.title }}</p>
        @for (line of notFoundDetail.text; track line) {
          <p class="text-muted">{{ line }}</p>
        }
        @if (returnBtnCallback !== undefined) {
          <button
            [id]="formLabel + 'ReturnBtn'"
            class="btn btn-light text-secondary mt-4 mb-2"
            (click)="returnBtnCallback()">
            {{ returnBtnLabel }}
          </button>
        }
      </div>
    }
  }
  <app-router-switch-btn
    [id]="formLabel + 'ToLoginBtn'"
    title="Login"
    urlLink="/login"></app-router-switch-btn>
</div>
